import React from 'react';
import FeatherIcon from 'feather-icons-react';

const ToolbarButton = ({
  active = false,
  disabled = false,
  label,
  onClick,
  className = '',
  children,
}) => (
  <button
    type="button"
    className={`bitacora-editor-toolbar-btn ${active ? 'is-active' : ''} ${className}`}
    disabled={disabled}
    onMouseDown={(e) => {
      e.preventDefault();
      if (!disabled) onClick();
    }}
    aria-pressed={active}
    title={label}
  >
    <span className="bitacora-editor-toolbar-btn-content">
      {children || label}
    </span>
  </button>
);

const Toolbar = ({ editor, disabled }) => {
  if (!editor) return null;

  const isDisabled = !!disabled;

  return (
    <div className="bitacora-editor-toolbar">
      <div className="bitacora-editor-toolbar-group">
        <ToolbarButton
          label="Negrita"
          className="bitacora-editor-toolbar-btn--bold"
          active={editor.isActive('bold')}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleBold().run()}
        >
          <span className="bitacora-editor-toolbar-text bitacora-editor-toolbar-text--bold">
            B
          </span>
        </ToolbarButton>
        <ToolbarButton
          label="Cursiva"
          active={editor.isActive('italic')}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleItalic().run()}
        >
          <FeatherIcon icon="italic" size={14} strokeWidth={2.2} />
        </ToolbarButton>
        <ToolbarButton
          label="Subrayado"
          active={editor.isActive('underline')}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleUnderline().run()}
        >
          <FeatherIcon icon="underline" size={14} strokeWidth={2.2} />
        </ToolbarButton>
      </div>

      <span className="bitacora-editor-toolbar-separator" />

      <div className="bitacora-editor-toolbar-group">
        <ToolbarButton
          label="Título 1"
          active={editor.isActive('heading', { level: 1 })}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        >
          <span className="bitacora-editor-toolbar-text">H1</span>
        </ToolbarButton>
        <ToolbarButton
          label="Título 2"
          active={editor.isActive('heading', { level: 2 })}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        >
          <span className="bitacora-editor-toolbar-text">H2</span>
        </ToolbarButton>
      </div>

      <span className="bitacora-editor-toolbar-separator" />

      <div className="bitacora-editor-toolbar-group">
        <ToolbarButton
          label="Lista con viñetas"
          active={editor.isActive('bulletList')}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleBulletList().run()}
        >
          <FeatherIcon icon="list" size={14} strokeWidth={2.2} />
        </ToolbarButton>
        <ToolbarButton
          label="Lista numerada"
          active={editor.isActive('orderedList')}
          disabled={isDisabled}
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
        >
          <span className="bitacora-editor-toolbar-text">1.</span>
        </ToolbarButton>
      </div>

      <span className="bitacora-editor-toolbar-separator" />

      <div className="bitacora-editor-toolbar-group">
        <ToolbarButton
          label="Deshacer (Ctrl/Cmd+Z)"
          disabled={isDisabled || !editor.can().chain().focus().undo().run()}
          onClick={() => editor.chain().focus().undo().run()}
        >
          <FeatherIcon icon="corner-up-left" size={14} strokeWidth={2.2} />
        </ToolbarButton>
        <ToolbarButton
          label="Rehacer (Ctrl/Cmd+Shift+Z)"
          disabled={isDisabled || !editor.can().chain().focus().redo().run()}
          onClick={() => editor.chain().focus().redo().run()}
        >
          <FeatherIcon icon="corner-up-right" size={14} strokeWidth={2.2} />
        </ToolbarButton>
      </div>
    </div>
  );
};

export default Toolbar;
